import React, { useCallback } from 'react'
import './theme.scss'
import { Link, useHistory, useRouteMatch } from 'react-router-dom'
import avatar from '../../assets/images/avatar.svg'
import CreateNewCustomerPopup from '../PopUp/CreateNewCustomerPopup'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import CancelNewCustomerPopup from '../PopUp/CancelNewCustomerPopup'
import {
    closeCancelNewCustomer,
    closeCreateNewCustomer,
    closeDealerProfilePopup,
    closeToast,
    onCancelNewCustomerConfirm,
    showCancelNewCustomer,
    showCreateNewCustomer,
    showDealerProfilePopup,
} from '../../actions/popupsActions'
import CustomerHasSkodaIdentPopup from '../PopUp/CustomerHasSkodaIdentPopup'
import DealerProfilePopup from '../PopUp/DealerProfilePopup'
import { useTranslation } from 'react-i18next'

function MainNavLinks({ label, to, type, showPopup }) {
    let match = useRouteMatch({
        path: to,
        exact: false,
    })
    const pathname = window.location.pathname

    let isCreate = false
    if (
        pathname === '/customer-information' ||
        pathname === '/skoda-ident' ||
        pathname === '/order-details' ||
        pathname === '/consent-verification'
    ) {
        isCreate = true
    }

    const checkUrl = (path) => {
        if (
            pathname === '/customer-information' ||
            pathname === '/skoda-ident' ||
            pathname === '/order-details' ||
            pathname === '/consent-verification'
        ) {
            showCancelNewCustomer(path)
            return true
        }
        return false
    }

    const checkAndShowPopupForCreate = () => {
        closeToast()
        if (!checkUrl('create')) {
            showPopup()
        }
    }

    const checkAndShowPopupForCustomers = (e) => {
        closeToast()
        if (checkUrl('customers')) {
            e.preventDefault()
        }
    }

    if (type !== 'createNewCustomer') {
        return (
            <Link
                className={`menu__item ${match ? 'active' : ''}`}
                to={to}
                onClick={checkAndShowPopupForCustomers}
            >
                {label}
            </Link>
        )
    } else {
        return (
            <div
                className={`menu__item ${isCreate ? 'active' : ''}`}
                onClick={checkAndShowPopupForCreate}
            >
                {label}
            </div>
        )
    }
}

const Logo = styled.div`
    width: 150px;
    cursor: pointer;
`

export default function Header(callback, deps) {
    const dispatch = useDispatch()
    const history = useHistory()
    const { t } = useTranslation('cba')
    const {
        createNewCustomerActive,
        cancelNewCustomerActive,
        cancelYesUrlAction,
        hasSkodaIdentActive,
        dealerProfilePopupActive,
    } = useSelector((state) => state.popups)

    const clickHomePage = useCallback(() => {
        history.push('/')
    }, [history])

    const onConfirmNewUser = (email) => {
        closeCreateNewCustomer()
        dispatch({
            type: 'SET_EMAIL',
            payload: {
                email: email,
            },
        })
        history.push({
            pathname: '/customer-information',
        })
    }

    const mainMenuItems = [
        {
            label: 'Dealership Customers',
            to: '/customers',
        },
        {
            label: t('general.header.createNewCustomer'),
            to: '/create',
            type: 'createNewCustomer',
        },
    ]

    const onCancelNewCustomer = () => {
        onCancelNewCustomerConfirm()
        history.push({
            pathname: '/customers',
        })
        if (cancelYesUrlAction === 'create') {
            showCreateNewCustomer()
        }
    }

    return (
        <div className="header">
            <Logo onClick={clickHomePage}>
                <img
                    className="main-menu__brand__image"
                    src="data:image/png;base64,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"
                    alt="Skoda Logo"
                    height="41"
                />
            </Logo>
            <div className="menu">
                {mainMenuItems.map((menuItem, i) => {
                    return (
                        <MainNavLinks
                            key={`nav-link-${i}`}
                            label={menuItem.label}
                            to={menuItem.to}
                            activeOnlyWhenExact={true}
                            type={menuItem.type}
                            showPopup={showCreateNewCustomer}
                        />
                    )
                })}
            </div>
            <div className="header__avatar" onClick={showDealerProfilePopup}>
                <img src={avatar} alt={'Profile'} />
            </div>
            <CreateNewCustomerPopup
                active={createNewCustomerActive}
                close={closeCreateNewCustomer}
                onConfirmNewUser={onConfirmNewUser}
            />
            <CancelNewCustomerPopup
                active={cancelNewCustomerActive}
                close={closeCancelNewCustomer}
                onYes={onCancelNewCustomer}
            />
            <CustomerHasSkodaIdentPopup active={hasSkodaIdentActive} />
            <DealerProfilePopup active={dealerProfilePopupActive} close={closeDealerProfilePopup} />
        </div>
    )
}
